import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Tax = lazy(() => retry(()=> import(/* webpackChunkName: "Tax" */ "./Tax")));

export default Tax;